
export const OakPlanningRecordType = {
    'Appeal': 'Appeal',
    'Creek Permit': 'Creek Permit',
    'Development Permit': 'Development Permit',
    'Environmental Review': 'Environmental Review',
    'Landmark Designation': 'Landmark Designation',
    'Letter of Determination': 'Letter of Determination',
    'Mills Act': 'Mills Act',
    'NEPA Exclusion Only': 'NEPA Exclusion Only',
    'NEPA Study': 'NEPA Study',
    'Planned Unit Developmen Final': 'Planned Unit Development Final',
    'Pre-Application': 'Pre-Application',
    'Revision': 'Revision',
    'Small Project DR': 'Small Project DR',
    'Zoning Clearance': 'Zoning Clearance',
    'Zoning Worksheet': 'Zoning Worksheet',
}

export const OakPlanningFileType = {
    'Application': 'Application',
    'Commission Submittal': 'Commission Submittal',
    // 'Correspondence': 'Correspondence',
    'CPC Motions and Resolutions': 'CPC Motions and Resolutions',
    'Environmental': 'Environmental',
    'Finance': 'Finance',
    'Letters of Determination': 'Letters of Determination',
    'Map': 'Map',
    // 'Notification': 'Notification',
    'Opposition Letter': 'Opposition Letter',
    'Other Planning Staff Document': 'Other Planning Staff Document',
    'Photographs': 'Photographs',
    'Planning Approval Letter': 'Planning Approval Letter',
    'Plans': 'Plans',
    'Staff report': 'Staff report',
    'Technical Reports': 'Technical Reports',
    'Zoning Verification Letters': 'Zoning Verification Letters',

    // 'PLN-Submittal-Maps': 'PLN-Submittal-Maps',
    // 'PLN-Email Notification': 'PLN-Email Notification',
    // 'CE-Inspection General': 'CE-Inspection General',
    // 'BLD-APPLICATION OR ISSUANCE REPORT': 'BLD-APPLICATION OR ISSUANCE REPORT',
    // 'ACA-ENERGY CALCULATIONS': 'ACA-ENERGY CALCULATIONS',
    // 'BLD-Other': 'BLD-Other',
    // 'PLN-SUBMITTAL-APPLICATION': 'PLN-SUBMITTAL-APPLICATION',
    // 'Email Notification': 'Email Notification',
    // 'PLN-Plans': 'PLN-Plans',
    // 'PLN-GENERAL': 'PLN-GENERAL',
    // 'Application or Issuance Report': 'Application or Issuance Report',
    // 'PLN-Submittal-Supplemental Forms': 'PLN-Submittal-Supplemental Forms',
    // 'FINANCE-GENERAL': 'FINANCE-GENERAL',
    // 'PLN-PLANS': 'PLN-PLANS',
    // 'PLN-SUBMITTAL-PHOTOGRAPHS': 'PLN-SUBMITTAL-PHOTOGRAPHS',
    // 'FINANCE-General': 'FINANCE-General',
    // 'CE-NOTIFICATIONS GENERAL': 'CE-NOTIFICATIONS GENERAL',
    // 'PLN-SUBMITTAL-MAPS': 'PLN-SUBMITTAL-MAPS',
    // 'Maps': 'Maps',
    // 'Staff Report': 'Staff Report',
    // 'PLN-SUBMITTAL-SUPPLEMENTAL FORMS': 'PLN-SUBMITTAL-SUPPLEMENTAL FORMS',
    // 'ACA-Energy Calculations': 'ACA-Energy Calculations',
    // 'ACA-Other': 'ACA-Other',
    // 'BLD-Application or Issuance Report': 'BLD-Application or Issuance Report',
    // 'PLN-Correspondence-Staff Report': 'PLN-Correspondence-Staff Report',
    // 'PLN-Submittal-Photographs': 'PLN-Submittal-Photographs',
    // 'ACA-OTHER': 'ACA-OTHER',
    // 'PLN-General': 'PLN-General',
    // 'PLN-Submittal-Application': 'PLN-Submittal-Application',
    // 'PLN-CORRESPONDENCE-STAFF REPORT': 'PLN-CORRESPONDENCE-STAFF REPORT',
    // 'PLN-ACA-General': 'PLN-ACA-General',
    // 'Application': 'Application',
    // 'Photographs': 'Photographs',
    // 'CE-General-NOV-Issued': 'CE-General-NOV-Issued',
    // 'PLN-EMAIL NOTIFICATION': 'PLN-EMAIL NOTIFICATION',
    // 'Plans': 'Plans',
    // 'Supplemental Forms': 'Supplemental Forms',
}

export const OakPlanningAdminFileType = {
    // 'PLN-Submittal-Maps': 'PLN-Submittal-Maps',
    // 'PLN-Email Notification': 'PLN-Email Notification',
    // 'CE-Inspection General': 'CE-Inspection General',
    // 'BLD-APPLICATION OR ISSUANCE REPORT': 'BLD-APPLICATION OR ISSUANCE REPORT',
    // 'ACA-ENERGY CALCULATIONS': 'ACA-ENERGY CALCULATIONS',
    // 'BLD-Other': 'BLD-Other',
    // 'PLN-SUBMITTAL-APPLICATION': 'PLN-SUBMITTAL-APPLICATION',
    // 'Email Notification': 'Email Notification',
    // 'PLN-Plans': 'PLN-Plans',
    // 'PLN-GENERAL': 'PLN-GENERAL',
    // 'Application or Issuance Report': 'Application or Issuance Report',
    // 'PLN-Submittal-Supplemental Forms': 'PLN-Submittal-Supplemental Forms',
    // 'FINANCE-GENERAL': 'FINANCE-GENERAL',
    // 'PLN-PLANS': 'PLN-PLANS',
    // 'PLN-SUBMITTAL-PHOTOGRAPHS': 'PLN-SUBMITTAL-PHOTOGRAPHS',
    // 'FINANCE-General': 'FINANCE-General',
    // 'CE-NOTIFICATIONS GENERAL': 'CE-NOTIFICATIONS GENERAL',
    // 'PLN-SUBMITTAL-MAPS': 'PLN-SUBMITTAL-MAPS',
    // 'Maps': 'Maps',
    // 'Staff Report': 'Staff Report',
    // 'PLN-SUBMITTAL-SUPPLEMENTAL FORMS': 'PLN-SUBMITTAL-SUPPLEMENTAL FORMS',
    // 'ACA-Energy Calculations': 'ACA-Energy Calculations',
    // 'ACA-Other': 'ACA-Other',
    // 'BLD-Application or Issuance Report': 'BLD-Application or Issuance Report',
    // 'PLN-Correspondence-Staff Report': 'PLN-Correspondence-Staff Report',
    // 'PLN-Submittal-Photographs': 'PLN-Submittal-Photographs',
    // 'ACA-OTHER': 'ACA-OTHER',
    // 'PLN-General': 'PLN-General',
    // 'PLN-Submittal-Application': 'PLN-Submittal-Application',
    // 'PLN-CORRESPONDENCE-STAFF REPORT': 'PLN-CORRESPONDENCE-STAFF REPORT',
    // 'PLN-ACA-General': 'PLN-ACA-General',
    'Application': 'Application',
    'Environmental': 'Environmental',
    'Commission Submittal': 'Commission Submittal',
    'CPC Motions and Resolutions': 'CPC Motions and Resolutions',
    'Correspondence': 'Correspondence',
    'Map': 'Map',
    'Notification': 'Notification',
    'Other Planning Staff Document': 'Other Planning Staff Document',
    'Opposition Letter': 'Opposition Letter',
    'Photographs': 'Photographs',
    // 'CE-General-NOV-Issued': 'CE-General-NOV-Issued',
    // 'PLN-EMAIL NOTIFICATION': 'PLN-EMAIL NOTIFICATION',
    'Planning Approval Letter': 'Planning Approval Letter',
    'Plans': 'Plans',
    // 'Supplemental Forms': 'Supplemental Forms',
    'Letters of Determination': 'Letters of Determination',
    'Technical Reports': 'Technical Reports',
    'Zoning Verification Letters': 'Zoning Verification Letters',
    'Other': 'Other',
}

export const OakZones = {
    'C-40': 'C-40',
    'C-45': 'C-45',
    'C-45/S-4': 'C-45/S-4',
    'CBD-C': 'CBD-C',
    'CBD-P': 'CBD-P',
    'CBD-P/CH': 'CBD-P/CH',
    'CBD-P/S-7': 'CBD-P/S-7',
    'CBD-R': 'CBD-R',
    'CBD-R/S-7': 'CBD-R/S-7',
    'CBD-X': 'CBD-X',
    'CBD-X/S-7': 'CBD-X/S-7',
    'CC-1': 'CC-1',
    'CC-2': 'CC-2',
    'CC-2/D-BR': 'CC-2/D-BR',
    'CC-2/S-7': 'CC-2/S-7',
    'CC-3': 'CC-3',
    'CIX-1': 'CIX-1',
    'CIX-1/S-19': 'CIX-1/S-19',
    'CIX-2': 'CIX-2',
    'CIX-2/S-19': 'CIX-2/S-19',
    'CN-1': 'CN-1',
    'CN-2': 'CN-2',
    'CN-2/D-BR': 'CN-2/D-BR',
    'CN-2/D-KP-3': 'CN-2/D-KP-3',
    'CN-2/S-12': 'CN-2/S-12',
    'CN-3': 'CN-3',
    'CN-3/D-KP-1': 'CN-3/D-KP-1',
    'CN-3/S-12': 'CN-3/S-12',
    'CN-3/S-7': 'CN-3/S-7',
    'CN-4': 'CN-4',
    'CR-1': 'CR-1',
    'D-KP-1': 'D-KP-1',
    'D-KP-2': 'D-KP-2',
    'D-KP-3': 'D-KP-3',
    'D-KP-4': 'D-KP-4',
    'D-OTN': 'D-OTN',
    'HBX-1': 'HBX-1',
    'HBX-2': 'HBX-2',
    'HBX-3': 'HBX-3',
    'IG': 'IG',
    'IG/S-19': 'IG/S-19',
    'IO': 'IO',
    'M-20/S-4': 'M-20/S-4',
    'M-30': 'M-30',
    'M-40': 'M-40',
    'M-40/S-4': 'M-40/S-4',
    'OS (AF)': 'OS (AF)',
    'OS (AMP)': 'OS (AMP)',
    'OS (CP)': 'OS (CP)',
    'OS (LP)': 'OS (LP)',
    'OS (LP)/S-10': 'OS (LP)/S-10',
    'OS (LP)/S-4': 'OS (LP)/S-4',
    'OS (NP)': 'OS (NP)',
    'OS (NP)/S-10': 'OS (NP)/S-10',
    'OS (NP)/S-12': 'OS (NP)/S-12',
    'OS (NP)/S-20': 'OS (NP)/S-20',
    'OS (NP)/S-4': 'OS (NP)/S-4',
    'OS (PMP)': 'OS (PMP)',
    'OS (RCA)': 'OS (RCA)',
    'OS (RCA)/S-10': 'OS (RCA)/S-10',
    'OS (RCA)/S-10/S-11': 'OS (RCA)/S-10/S-11',
    'OS (RCA)/S-11': 'OS (RCA)/S-11',
    'OS (RCA)/S-4': 'OS (RCA)/S-4',
    'OS (RSP)': 'OS (RSP)',
    'OS (SU)': 'OS (SU)',
    'OS (SU)/S-4': 'OS (SU)/S-4',
    'OS(CP)/S-20': 'OS(CP)/S-20',
    'OS(LP)/S-4': 'OS(LP)/S-4',
    'OS(NP)/S-20': 'OS(NP)/S-20',
    'OS(PMP)': 'OS(PMP)',
    'R-80': 'R-80',
    'RD-1': 'RD-1',
    'RD-1/S-20': 'RD-1/S-20',
    'RD-2': 'RD-2',
    'RD-2/S-20': 'RD-2/S-20',
    'RH-1': 'RH-1',
    'RH-1/S-10': 'RH-1/S-10',
    'RH-1/S-10/S-11': 'RH-1/S-10/S-11',
    'RH-1/S-11': 'RH-1/S-11',
    'RH-2': 'RH-2',
    'RH-2/S-10': 'RH-2/S-10',
    'RH-2/S-10/S-11': 'RH-2/S-10/S-11',
    'RH-2/S-11': 'RH-2/S-11',
    'RH-3': 'RH-3',
    'RH-3/S-10': 'RH-3/S-10',
    'RH-3/S-10/S-11': 'RH-3/S-10/S-11',
    'RH-3/S-11': 'RH-3/S-11',
    'RH-4': 'RH-4',
    'RH-4/S-10': 'RH-4/S-10',
    'RH-4/S-10/S-11': 'RH-4/S-10/S-11',
    'RH-4/S-11': 'RH-4/S-11',
    'RM-1': 'RM-1',
    'RM-1/S-12': 'RM-1/S-12',
    'RM-2': 'RM-2',
    'RM-2/C': 'RM-2/C',
    'RM-2/S-10': 'RM-2/S-10',
    'RM-2/S-20': 'RM-2/S-20',
    'RM-2/S-7': 'RM-2/S-7',
    'RM-3': 'RM-3',
    'RM-3/C': 'RM-3/C',
    'RM-3/D-BR': 'RM-3/D-BR',
    'RM-3/S-12': 'RM-3/S-12',
    'RM-3/S-20': 'RM-3/S-20',
    'RM-4': 'RM-4',
    'RM-4/C': 'RM-4/C',
    'RM-4/C/S-20': 'RM-4/C/S-20',
    'RM-4/D-BR': 'RM-4/D-BR',
    'RM-4/S-12': 'RM-4/S-12',
    'RM-4/S-20': 'RM-4/S-20',
    'RU-1': 'RU-1',
    'RU-1/S-12': 'RU-1/S-12',
    'RU-1/S-20': 'RU-1/S-20',
    'RU-2': 'RU-2',
    'RU-2/S-12': 'RU-2/S-12',
    'RU-3': 'RU-3',
    'RU-3/D-BR': 'RU-3/D-BR',
    'RU-3/S-12': 'RU-3/S-12',
    'RU-3/S-20': 'RU-3/S-20',
    'RU-3/S-7/S-12': 'RU-3/S-7/S-12',
    'RU-4': 'RU-4',
    'RU-4/D-BR': 'RU-4/D-BR',
    'RU-5': 'RU-5',
    'S-1': 'S-1',
    'S-15': 'S-15',
    'S-2': 'S-2',
    'S-3': 'S-3',
    'Wood Street': 'Wood Street',
}

export const OakGpClassifications = {
    'Business Mix': 'Business Mix',
    'Central Business District': 'Central Business District',
    'Community Commercial': 'Community Commercial',
    'Detached Unit Residential': 'Detached Unit Residential',
    'Estuary Policy Plan Area': 'Estuary Policy Plan Area',
    'General Industry and Transportation': 'General Industry and Transportation',
    'Hillside Residential': 'Hillside Residential',
    'Housing and Business Mix': 'Housing and Business Mix',
    'Institutional': 'Institutional',
    'Mixed Housing Type Residential': 'Mixed Housing Type Residential',
    'Neighborhood Center Mixed Use': 'Neighborhood Center Mixed Use',
    'Regional Commercial': 'Regional Commercial',
    'Resource Conservation': 'Resource Conservation',
    'Urban Park and Open Space': 'Urban Park and Open Space',
    'Urban Residential': 'Urban Residential',
}

export const DistanceMile = [
    {value: "0", display: "Any distance"},
    {value: "0.125", display: "Within 1/8 mile"},
    {value: "0.25", display: "Within 1/4 mile"},
    {value: "0.5", display: "Within 1/2 mile"},
    {value: "0.75", display: "Within 3/4 mile"},
    {value: "1.0", display: "Within 1 mile"},
    {value: "1.25", display: "Within 1 1/4 miles"},
    {value: "1.5", display: "Within 1 1/2 miles"},
    {value: "1.75", display: "Within 1 3/4 miles"},
    {value: "2", display: "Within 2 miles"},
    {value: "2.5", display: "Within 2 1/2 miles"},
    {value: "3", display: "Within 3 miles"},
    {value: "3.5", display: "Within 3 1/2 miles"},
    {value: "4", display: "Within 4 miles"},
    {value: "4.5", display: "Within 4 1/2 miles"},
    {value: "5", display: "Within 5 miles"},
    {value: "5.5", display: "Within 5 1/2 miles"},
    {value: "6", display: "Within 6 miles"},
    {value: "7", display: "Within 7 miles"},
    {value: "8", display: "Within 8 miles"},
    {value: "9", display: "Within 9 miles"},
]

export const OakRecordStatus = {
    'Open': 'open',
    'Closed/completed': 'closed',
    'Canceled/incomplete': 'canceled_incomplete',
    'Withdrawn': 'withdrawn',
}